export default "__VITE_ASSET__x2WJPy32__"